export const normalizeText = (text: string) => text.replaceAll('</p>', '\n').replace(/(<(\/?[^>]+)>)/g, '').replace(/&nbsp;/g, ' ');
